import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { GenericList } from 'src/app/models/list-item.model';
import { AlumnoService } from 'src/app/services/alumno.service';
import { ConstService } from 'src/app/services/const.service';
import { EscuelaService } from 'src/app/services/escuela.service';
import { GradoService } from 'src/app/services/grado.service';

import Swal from 'sweetalert2';

import { IngresoEgreso } from '../../../../models/ingresoegreso.model';
import { IngresoEgresoService } from '../../../../services/ingresosegreso.service';
import { Alumno } from 'src/app/models/alumno.model';
import { Grado } from 'src/app/models/grado.model';

@Component({
  selector: 'app-ingresoegreso-edit',
  templateUrl: './ingresoegreso-edit.component.html',
  styleUrls: ['./ingresoegreso-edit.component.css']
})
export class IngresoEgresoEditComponent implements OnInit, OnDestroy {

  public ingresoEgreso: IngresoEgreso = new IngresoEgreso(0, '', 0, new Date(), 0, true,'','','',{} as Alumno,{} as Grado,0);
  id;
  grados = [];
  alumnos = [];
  gradoId = 0;
  alumnoId = 0;
  formaPagoId = 0;
  formaDePagoS!: GenericList;

  private destroy$ = new Subject<void>();

  constructor(private service: IngresoEgresoService,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              private escuelaService: EscuelaService,
              private gradosService: GradoService,
              private alumnoService: AlumnoService,
              private constService: ConstService) { 
              }

  ngOnInit(): void {
    this.id = this.activatedRoute.snapshot.paramMap.get('id');
    this.gradosService.getGradosPorEscuelaNoPaging()
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe(c => this.grados = c.resultList);
    
    this.formaDePagoS = this.constService.getFormapago();

    if (this.id && this.id !== 'new') {
          this.service.getIngresoEgresosPorId(this.id)
            .pipe(takeUntil(this.destroy$))
            .subscribe((resp: any) => {
              this.ingresoEgreso = resp.resultList[0];
              this.gradoId = this.ingresoEgreso?.grado?.id;
              if(!!this.ingresoEgreso?.grado){
                this.gradoChange(this.ingresoEgreso?.grado?.id);
              }
            });
        }else{
          this.ingresoEgreso = new IngresoEgreso(null, '', 0, new Date(), this.escuelaService.Escuela().id, true,'','','',{} as Alumno,{} as Grado,0);
        }
  }
  gradoChange(valor){
    this.alumnoService.getAlumnosPorEscuelaYGrado(valor)
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe(c => {
        this.alumnos = c.resultList;
        this.alumnoId = this.ingresoEgreso?.alumno?.id;
      });
  }
  save() {
    let g = this.grados.find(g => g.id.toString() === this.gradoId);
		if (g) {
			this.ingresoEgreso.grado = g;
		}

    let a = this.alumnos.find(g => g.id.toString() === this.alumnoId);
		if (a) {
			this.ingresoEgreso.alumno = a;
		}

    const save$: Observable<IngresoEgreso> = (this.id && this.id !== 'new') ?
      this.service.update(this.ingresoEgreso) :
      this.service.create(this.ingresoEgreso);

    save$.pipe(takeUntil(this.destroy$)).subscribe(resp => {
      this.router.navigate(['/ingresoegreso']);
    },
    (err) => {
      Swal.fire('Error', err.error.msg, 'error');
    });
  }

  setFecha(evento: Date){
		this.ingresoEgreso.fecha = evento;
	}

  volver(): void {
    this.router.navigate(['/ingresoegreso']);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
